import { useState } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { Link } from 'react-router-dom';
import CTASection from '@/pages/home/components/CTASection';

export default function AboutPage() {
  const [formStatus, setFormStatus] = useState<'idle' | 'submitting' | 'success' | 'error'>('idle');
  const [formError, setFormError] = useState('');

  const handleCooperationSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);

    const honeypot = formData.get('phone_alt');
    if (honeypot && String(honeypot).trim() !== '') {
      setFormStatus('success');
      setTimeout(() => setFormStatus('idle'), 3000);
      return;
    }
    formData.delete('phone_alt');

    setFormStatus('submitting');
    setFormError('');

    try {
      const body = new URLSearchParams();
      formData.forEach((value, key) => {
        body.append(key, String(value));
      });

      const res = await fetch('http://bestyoungman.com/', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: body.toString(),
      });

      const responseText = await res.text();
      let parsed: any = {};
      try { parsed = JSON.parse(responseText); } catch (_) { /* ignore */ }

      if (res.ok && parsed?.code === 'OK') {
        setFormStatus('success');
        form.reset();
        setTimeout(() => setFormStatus('idle'), 3000);
      } else {
        const serverMsg = parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText || '提交失败，请稍后重试';
        setFormError(serverMsg);
        setFormStatus('error');
      }
    } catch {
      setFormError('网络错误，请检查连接后重试');
      setFormStatus('error');
    }
  };

  return (
    <>
      <Navbar />
      <main>
        <section className="relative w-full h-[360px] md:h-[440px] flex items-center justify-center overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Artistic%20warm-toned%20abstract%20illustration%20with%20soft%20golden%20and%20cream%20gradients%2C%20subtle%20book%20and%20reading%20motifs%20blended%20ethereally%20into%20a%20dreamy%20background%2C%20bottom%20section%20featuring%20gentle%20silhouettes%20of%20people%20reading%20together%2C%20top%20section%20open%20and%20airy%20with%20warm%20diffused%20light%2C%20modern%20digital%20art%20style%2C%20editorial%20composition%2C%20harmonious%20warm%20palette%2C%20elegant%20minimalist%20aesthetic%2C%20community%20reading%20atmosphere&width=1920&height=1080&seq=about-hero-2026&orientation=landscape"
            alt="关于我们 - 韩漫网站"
            className="absolute inset-0 w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/20 to-black/45"></div>
          <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center">
            <nav className="flex items-center justify-center gap-2 text-sm text-white/70 mb-4">
              <Link to="/" className="hover:text-white transition-colors cursor-pointer">首页</Link>
              <i className="ri-arrow-right-s-line text-xs"></i>
              <span className="text-white">关于我们</span>
            </nav>
            <h1 className="font-heading text-3xl md:text-5xl font-black text-white leading-tight tracking-tight mb-4">
              关于韩漫网站
            </h1>
            <p className="text-sm md:text-base text-white/80 max-w-xl mx-auto leading-relaxed">
              了解我们的品牌故事、核心优势与联系方式
            </p>
          </div>
        </section>

        <section className="bg-background-50 pt-16 md:pt-24 pb-12">
          <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-10">
            <div className="flex flex-col lg:flex-row gap-10 lg:gap-16 items-center">
              <div className="lg:w-1/2">
                <div className="rounded-3xl overflow-hidden bg-background-100">
                  <img
                    src="https://readdy.ai/api/search-image?query=Warm%20artistic%20illustration%20of%20a%20cozy%20modern%20reading%20space%20with%20comfortable%20seating%2C%20warm%20ambient%20lighting%2C%20shelves%20filled%20with%20colorful%20comic%20books%20and%20manga%20volumes%2C%20plants%20adding%20natural%20texture%2C%20peaceful%20community%20atmosphere%2C%20golden%20hour%20light%20streaming%20through%20windows%2C%20lifestyle%20editorial%20photography%20style%2C%20warm%20amber%20and%20cream%20tones%2C%20inviting%20peaceful%20mood%2C%20high%20quality&width=900&height=675&seq=about-brand-01&orientation=landscape"
                    alt="韩漫网站品牌形象"
                    className="w-full aspect-[4/3] object-cover"
                    loading="lazy"
                  />
                </div>
              </div>
              <div className="lg:w-1/2">
                <span className="inline-block px-3 py-1 bg-accent-100 text-accent-600 text-xs font-medium rounded-full mb-4">
                  品牌介绍
                </span>
                <h2 className="font-heading text-3xl md:text-4xl font-black text-foreground-950 leading-tight mb-5">
                  致力于打造最好的<br />韩漫阅读平台
                </h2>
                <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
                  韩漫网站成立于2024年，是一个专注于韩国漫画的免费在线阅读平台。我们汇聚了数千部优质韩漫作品，涵盖热血、恋爱、奇幻、武侠、都市、校园等多种类型，致力于为华语地区的韩漫爱好者提供最优质的阅读体验。
                </p>
                <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6">
                  平台采用先进的下拉式阅读技术，适配手机、平板和电脑等全终端设备，让读者随时随地都能流畅阅读。同时我们坚持免费正版授权模式，让每一位用户都能零门槛畅享精彩内容。
                </p>
                <div className="flex items-center gap-6">
                  <div>
                    <p className="text-2xl font-bold text-primary-500">5000+</p>
                    <p className="text-xs text-foreground-500">漫画作品</p>
                  </div>
                  <div className="w-px h-10 bg-background-300"></div>
                  <div>
                    <p className="text-2xl font-bold text-accent-500">500万+</p>
                    <p className="text-xs text-foreground-500">月活用户</p>
                  </div>
                  <div className="w-px h-10 bg-background-300"></div>
                  <div>
                    <p className="text-2xl font-bold text-secondary-500">99.7%</p>
                    <p className="text-xs text-foreground-500">好评率</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="bg-background-100 py-16 md:py-24">
          <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-10">
            <div className="text-center mb-12">
              <p className="text-sm text-foreground-500 font-medium tracking-wider uppercase mb-3">
                平台优势
              </p>
              <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-black text-foreground-950 leading-tight">
                为什么千万读者选择我们
              </h2>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
              <div className="bg-background-50 rounded-2xl p-6 md:p-8">
                <div className="w-12 h-12 rounded-xl bg-accent-100 flex items-center justify-center mb-5">
                  <i className="ri-book-open-line text-xl text-accent-500"></i>
                </div>
                <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-3">海量正版资源</h3>
                <p className="text-sm text-foreground-600 leading-relaxed">收录超过5000部正版授权的韩国漫画作品，覆盖全品类题材，满足不同读者的阅读喜好。每日同步更新热门连载最新章节。</p>
              </div>
              <div className="bg-background-50 rounded-2xl p-6 md:p-8">
                <div className="w-12 h-12 rounded-xl bg-primary-100 flex items-center justify-center mb-5">
                  <i className="ri-smartphone-line text-xl text-primary-500"></i>
                </div>
                <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-3">极致的阅读体验</h3>
                <p className="text-sm text-foreground-600 leading-relaxed">专为移动端优化的下拉式阅读模式，加载速度快，画质高清。无需翻页即可沉浸式连续阅读，带来如丝般顺滑的浏览享受。</p>
              </div>
              <div className="bg-background-50 rounded-2xl p-6 md:p-8">
                <div className="w-12 h-12 rounded-xl bg-secondary-100 flex items-center justify-center mb-5">
                  <i className="ri-shield-check-line text-xl text-secondary-500"></i>
                </div>
                <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-3">安全可靠</h3>
                <p className="text-sm text-foreground-600 leading-relaxed">平台所有内容均获得官方授权，严格保护用户隐私，提供安全稳定的阅读环境。零广告干扰，纯粹专注阅读体验。</p>
              </div>
            </div>
          </div>
        </section>

        <section className="bg-background-50 py-16 md:py-24">
          <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-10">
            <div className="flex flex-col lg:flex-row gap-10 lg:gap-16">
              <div className="lg:w-1/2">
                <h2 className="font-heading text-3xl md:text-4xl font-black text-foreground-950 leading-tight mb-6">
                  联系我们
                </h2>
                <p className="text-sm text-foreground-600 leading-relaxed mb-8">
                  如果您有任何问题、建议或合作意向，欢迎通过以下方式联系我们。我们会在24小时内回复您的消息。
                </p>
                <div className="flex flex-col gap-5">
                  <div className="flex items-start gap-4">
                    <div className="w-10 h-10 rounded-xl bg-accent-100 flex items-center justify-center flex-shrink-0">
                      <i className="ri-mail-line text-accent-500"></i>
                    </div>
                    <div>
                      <p className="text-sm font-medium text-foreground-900 mb-0.5">电子邮箱</p>
                      <p className="text-sm text-foreground-600">hello@bestyoungman.com</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-4">
                    <div className="w-10 h-10 rounded-xl bg-primary-100 flex items-center justify-center flex-shrink-0">
                      <i className="ri-customer-service-2-line text-primary-500"></i>
                    </div>
                    <div>
                      <p className="text-sm font-medium text-foreground-900 mb-0.5">客服微信</p>
                      <p className="text-sm text-foreground-600">HanMan_Official</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-4">
                    <div className="w-10 h-10 rounded-xl bg-secondary-100 flex items-center justify-center flex-shrink-0">
                      <i className="ri-map-pin-line text-secondary-500"></i>
                    </div>
                    <div>
                      <p className="text-sm font-medium text-foreground-900 mb-0.5">公司地址</p>
                      <p className="text-sm text-foreground-600">北京市朝阳区建国路88号SOHO现代城A座</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="lg:w-1/2">
                <div className="rounded-3xl overflow-hidden bg-background-100">
                  <iframe
                    src="http://bestyoungman.com/maps/embed?pb=!1m18!1m12!1m3!1d3061.237684539456!2d116.4603!3d39.9092!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x35f05103a4f0e0e9%3A0x83faf2c0d8d28044!2sSOHO%20Modern%20City%2C%20Chaoyang%20District%2C%20Beijing!5e0!3m2!1szh-CN!2scn!4v1680000000000"
                    width="100%"
                    height="340"
                    style={{ border: 0 }}
                    allowFullScreen
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                    title="韩漫网站公司位置"
                    className="w-full"
                  ></iframe>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="bg-background-100 py-16 md:py-24">
          <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-10">
            <div className="flex flex-col lg:flex-row gap-10 lg:gap-16">
              <div className="lg:w-1/2">
                <span className="inline-block px-3 py-1 bg-accent-100 text-accent-600 text-xs font-medium rounded-full mb-4">
                  商务合作
                </span>
                <h2 className="font-heading text-3xl md:text-4xl font-black text-foreground-950 leading-tight mb-5">
                  期待与您的合作
                </h2>
                <p className="text-sm text-foreground-600 leading-relaxed mb-6">
                  韩漫网站开放多种合作模式，欢迎内容提供方、广告主、品牌方等联系我们洽谈合作事宜。我们拥有500万+月活韩漫用户，精准垂直的流量资源和高效的内容分发能力，是您触达韩漫爱好者群体的最佳选择。
                </p>
                <div className="flex flex-col gap-4 mb-6">
                  <div className="flex items-start gap-3">
                    <div className="w-8 h-8 rounded-lg bg-accent-100/70 flex items-center justify-center flex-shrink-0 mt-0.5">
                      <i className="ri-shake-hands-line text-sm text-accent-500"></i>
                    </div>
                    <div>
                      <p className="text-sm font-medium text-foreground-900">内容版权合作</p>
                      <p className="text-xs text-foreground-500 mt-0.5">漫画版权授权引进、独家合作、汉化发行合作</p>
                      <p className="text-xs text-foreground-600 mt-1">联系邮箱：hello@bestyoungman.com</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <div className="w-8 h-8 rounded-lg bg-primary-100/70 flex items-center justify-center flex-shrink-0 mt-0.5">
                      <i className="ri-advertisement-line text-sm text-primary-500"></i>
                    </div>
                    <div>
                      <p className="text-sm font-medium text-foreground-900">广告投放合作</p>
                      <p className="text-xs text-foreground-500 mt-0.5">开屏广告、Banner位、原生信息流等多种广告形式</p>
                      <p className="text-xs text-foreground-600 mt-1">联系邮箱：hello@bestyoungman.com</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <div className="w-8 h-8 rounded-lg bg-secondary-100/70 flex items-center justify-center flex-shrink-0 mt-0.5">
                      <i className="ri-briefcase-line text-sm text-secondary-500"></i>
                    </div>
                    <div>
                      <p className="text-sm font-medium text-foreground-900">品牌联合推广</p>
                      <p className="text-xs text-foreground-500 mt-0.5">品牌联名活动、IP跨界合作、线上线下联动营销</p>
                      <p className="text-xs text-foreground-600 mt-1">联系邮箱：hello@bestyoungman.com</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="lg:w-1/2">
                <div className="bg-background-50 rounded-3xl p-6 md:p-8">
                  <h3 className="font-heading text-xl font-semibold text-foreground-900 mb-5">发送合作咨询</h3>
                  <form
                   
                    id="cooperation-form"
                    onSubmit={handleCooperationSubmit}
                    className="flex flex-col gap-4"
                  >
                    <div>
                      <input
                        type="text"
                        name="name"
                        required
                        placeholder="您的姓名或公司名称"
                        className="w-full px-4 py-3 bg-background-100 rounded-xl text-sm text-foreground-800 placeholder:text-foreground-400 outline-none focus:ring-2 focus:ring-primary-300 transition-all"
                      />
                    </div>
                    <div>
                      <input
                        type="email"
                        name="email"
                        required
                        placeholder="您的电子邮箱"
                        className="w-full px-4 py-3 bg-background-100 rounded-xl text-sm text-foreground-800 placeholder:text-foreground-400 outline-none focus:ring-2 focus:ring-primary-300 transition-all"
                      />
                    </div>
                    <div>
                      <select
                        name="cooperation_type"
                        required
                        defaultValue=""
                        className="w-full px-4 py-3 bg-background-100 rounded-xl text-sm text-foreground-800 outline-none focus:ring-2 focus:ring-primary-300 transition-all appearance-none cursor-pointer"
                      >
                        <option value="" disabled>请选择合作类型</option>
                        <option value="content">内容版权合作</option>
                        <option value="ad">广告投放合作</option>
                        <option value="brand">品牌联合推广</option>
                        <option value="other">其他合作</option>
                      </select>
                    </div>
                    <div>
                      <textarea
                        name="message"
                        required
                        rows={4}
                        maxLength={500}
                        placeholder="请简要描述您的合作需求（500字以内）"
                        className="w-full px-4 py-3 bg-background-100 rounded-xl text-sm text-foreground-800 placeholder:text-foreground-400 outline-none focus:ring-2 focus:ring-primary-300 transition-all resize-none"
                      ></textarea>
                    </div>
                    <input
                      type="text"
                      name="phone_alt"
                      tabIndex={-1}
                      autoComplete="off"
                      aria-hidden="true"
                      readOnly
                      className="absolute opacity-0 pointer-events-none"
                    />
                    {formError && (
                      <p className="text-sm text-red-500">{formError}</p>
                    )}
                    <button
                      type="submit"
                      disabled={formStatus === 'submitting'}
                      className="w-full px-6 py-3 bg-primary-500 text-background-50 font-medium rounded-full text-sm hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap disabled:opacity-50"
                    >
                      {formStatus === 'submitting' ? '提交中...' : formStatus === 'success' ? '已发送！我们会尽快联系您' : '发送合作咨询'}
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </section>

        <CTASection />
      </main>
      <Footer />

      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "AboutPage",
          "name": "关于韩漫网站",
          "description": "韩漫网站致力于为华语地区韩漫爱好者提供优质的免费在线观看服务。收录5000+正版韩国漫画作品，支持下拉式流畅阅读，月活用户500万+，好评率99.7%。",
          "url": "http://bestyoungman.com/about",
          "isPartOf": {
            "@type": "WebSite",
            "name": "韩漫网站",
            "url": "http://bestyoungman.com/"
          }
        })}
      </script>

      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          "itemListElement": [
            { "@type": "ListItem", "position": 1, "name": "首页", "item": "http://bestyoungman.com/" },
            { "@type": "ListItem", "position": 2, "name": "关于我们", "item": "http://bestyoungman.com/about" }
          ]
        })}
      </script>
    </>
  );
}